module.exports = __webpack_public_path__ + "instagram.63eaad6fcb2b70e4de527b2921064331.svg";